import { debounce } from 'lodash'

export default (...args) => {
  const debounced = (debounce as any)(...args)
  return e => {
    if (e) e.persist()
    return debounced(e)
  }
}
